var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-survey-select-activity-analyze"},[_c('h4',[_vm._v("ポジティブ回答時の選択アクティビティ")]),_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":[].concat( _vm.surveyAnalysisTabels )},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getActivityName(row.id)))])]}},{key:"count",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.pointList[0].items))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }